import type { AtAGlanceOutput } from './atAGlanceTypes.ts';

type SingleEntryCache<TValue> = {
	get: (key: string) => TValue | undefined;
	set: (key: string, value: TValue) => void;
	clear: () => void;
};

const createSingleEntryCache = <TValue>(): SingleEntryCache<TValue> => {
	let entry: { key: string; value: TValue } | undefined;

	return {
		get: (key) => (entry?.key === key ? entry.value : undefined),
		set: (key, value) => {
			entry = { key, value };
		},
		clear: () => {
			entry = undefined;
		},
	};
};

// Reuse only the most recent successful response. This survives panel/modal
// remounts without accumulating one entry per page, and the exact request body
// makes every input that can affect the summaries part of cache identity.
// This intentionally has no TTL: backend-only prompt or model changes are not
// observed until another success replaces the entry or the page reloads. That
// trade-off is acceptable because this cache targets immediate consecutive opens.
export const atAGlanceResultCache: SingleEntryCache<AtAGlanceOutput> =
	createSingleEntryCache<AtAGlanceOutput>();
